import getEnvironment from "./get-environment";

async function fetchGraphql({
                                graphQLEndpoint = getEnvironment().graphQLEndpoint,
                                query,
                                headers = {},
                            }) {
    const response = await fetch(graphQLEndpoint, {
        method: "POST",
        headers: Object.assign({
                'Content-Type': 'application/json',
            },
            headers,
            {
                Accept: 'application/json,multipart/mixed; deferSpec=20220824',
            }
        ),
        body: query,
        credentials: "same-origin",
    });
    if (response.ok) {
        return response.json();
    }
    throw Error('Error executing GraphQL query: ' + response.text());
}

export default fetchGraphql;
